import confetti from "canvas-confetti";

const COLORS = ["#ff0", "#f0f", "#0ff", "#f00", "#0f0", "#00f", "#ff8800", "#ff0088"];

let confettiInterval = null;

export function startConfetti () {
  stopConfetti();
  confettiInterval = setInterval(() => {
    for (let i = 0; i < 5; i++) {
      confetti({
        particleCount: 1,
        startVelocity: 3,
        gravity: 1.0,
        spread: 0,
        colors: [COLORS[Math.floor(Math.random() * COLORS.length)]],
        decay: 0.03,
        origin: { x: Math.random(), y: -0.05 }
      });
    }
  }, 300);
}

export function stopConfetti () {
  if (confettiInterval) {
    clearInterval(confettiInterval);
    confettiInterval = null;
  }
}